import ruleNames from '../../../constants/ruleNames';

const ongoingRules = [
  ruleNames.ADVERSE_MEDIA,
  ruleNames.BUSINESS_DATA_CHANGED,
  ruleNames.BUSINESS_SANCTION_LIST,
  ruleNames.CONNECTED_ENTITY_PEP,
  ruleNames.CONNECTED_ENTITY_SANCTION_LIST,
  ruleNames.DUE_DILIGENCE,
  ruleNames.INDIVIDUAL_PEP,
  ruleNames.INDIVIDUAL_SANCTION_LIST,
  ruleNames.SPAR_CHANGED,
  ruleNames.MERCHANT_CATEGORY_CODE_BLOCKLIST,
] as const;

export default ongoingRules;
